import styled from "styled-components";

export const ContainerCloseRound = styled.div`
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid ${props => props.theme.colors.neutral200};
    background: ${props => props.theme.colors.white};
    transition: border-color 200ms ease, color 200ms ease;

    svg {
        width: 18px;
        height: 18px;
        color: ${props => props.theme.colors.neutral900};
    }

    &:hover {
        border-color: ${props => props.theme.colors.primary};
        svg {
            color: ${props => props.theme.colors.primary};
        }
    }
`;
